/* global NetworkConfig */
import React from 'react';
import PropTypes from 'prop-types';
import { renderImage } from 'helpers/ImageHelper';
import Style from './NetworkImage.module.scss';

const NetworkImage = ({ network, title, alt }) => {
  const logos = window?.ExternalConfig?.appLogo;
  const mobileSrc = logos?.mobile;
  const desktopSrc = logos?.desktop;
  const altText = alt || `${network} logo`;
  return (
    <>
      {renderImage({ alt: altText, src: mobileSrc, title, className: Style.mobileLogo })}
      {renderImage({ alt: altText, src: desktopSrc, title, className: Style.desktopLogo })}
    </>
  );
};

NetworkImage.defaultProps = {
  alt: '',
  network: NetworkConfig.branding,
  title: null,
};

NetworkImage.propTypes = {
  alt: PropTypes.string,
  network: PropTypes.string,
  title: PropTypes.string,
};

export default NetworkImage;
